// src/components/ui/layout/AuthHeader/AuthHeader.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const AuthHeader = ({
  icon: Icon,
  title,
  subtitle,
  iconGradient = "from-blue-500 to-purple-600",
  iconShadow = "shadow-blue-500/25",
  className = ''
}) => {
  return (
    <div className={cn("text-center mb-8", className)}>
      {/* Icon */}
      {Icon && (
        <div className={cn(
          "inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 shadow-lg",
          `bg-gradient-to-br ${iconGradient}`,
          iconShadow
        )}>
          <Icon className="w-8 h-8 text-white" />
        </div>
      )}
      
      {/* Title */}
      {title && (
        <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-100 to-slate-300 bg-clip-text text-transparent mb-2">
          {title}
        </h1>
      )}
      
      {/* Subtitle */}
      {subtitle && (
        <p className="text-slate-400">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default AuthHeader;